import React from "react";
import { Helmet } from "react-helmet";
import { Col, Row, Typography } from "antd";
import "./Query.css";

export default function Query() {
  return (
    <div className="query-page-main">
      <Helmet>
        <link rel="canonical" href="https://www.jaipurmasale.com/query" />
      </Helmet>
      <h2 className="query-title">Why Us?</h2>
      <hr />
      <div className="query-description">
        <Row>
          <Col lg={1} xs={2}></Col>
          <Col lg={22} xs={20}>
            <Row>
              <Col lg={11} xs={24}>
                <div>
                  {/* <Typography className="query-section-title">
                    Why Switch to Jaipur Masale & Dry Fruits?
                  </Typography> */}
                  <Typography className="query-text">
                    If you're still reading this, we are pretty sure you already
                    recognize the benefit of buying from us. However, if you are
                    still not convinced, here's a few extra points to change your
                    mind
                  </Typography>
                  <div className="listed-text">
                    <ul>
                      <li>Handmade with Love </li>
                      <li>Preserving Indian Heritage</li>
                      <li>Versatile Product Range</li>
                      <li>Locally Sourced Materials</li>
                      <li>Ethical Fashion & Décor</li>
                      <li>Handcrafted Luxury at Your Doorstep</li>
                      <li>Cultural Storytelling Through Design</li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={1} xs={2}></Col>
        </Row>
      </div>
    </div>
  );
}
